/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assignment_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Assignment updated successfully" |
*
* @param {Explorer_Info_Assignment_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assignment_updated_toast = /** @type {((inputs?: Explorer_Info_Assignment_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assignment_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affectation mise a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufgabe erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnazione aggiornata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание успешно обновлено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignación actualizada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("任务已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("課題が正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असाइनमेंट सफलतापूर्वक अपडेट हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa atualizada com sucesso")
	return /** @type {LocalizedString} */ ("Assignment updated successfully")
});